import { debugLog } from '../utils/debugUtils';

const TUTORIAL_DONE_KEY = 'concordare_tutorial_done';

class TutorialService {
  shouldShowTutorial() {
    return localStorage.getItem(TUTORIAL_DONE_KEY) !== 'true';
  }

  markTutorialDone() {
    localStorage.setItem(TUTORIAL_DONE_KEY, 'true');
    debugLog('[TutorialService] Tutorial marked as done');
  }

  resetTutorial() {
    localStorage.removeItem(TUTORIAL_DONE_KEY);
    debugLog('[TutorialService] Tutorial reset');
  }
}

export default new TutorialService();
